import { axios } from "../config";

function fetchSubjectsAcademicView(id) {
  return axios.get("api/v1/subjects/academic-view");
}

function fetchSubjectStats() {
  return axios.get("api/v1/subjects/stats");
}

function fetchNonAcademicStats(type) {
  return axios.get(`api/v1/students/activities?type=${type}`);
}
function fetchStudentActivities(data) {
  return axios.get("api/v1/students/activities", {
    params: data,
  });
}
function createInstitutionActivity(data) {
  return axios.post(`api/v1/students/activities`, data);
}
function updateInstitutionActivity(id, data) {
  return axios.post(`api/v1/students/activities/${id}`, data);
}
function deleteInstitutionActivity(id) {
  return axios.delete(`api/v1/students/activities/${id}`);
}

function fetchSubjectTypes(data) {
  return axios.get(`api/v1/departments`, {
    params: data,
  });
}

function fetchSubjectList(data) {
  return axios.get("api/v1/subjects", {
    params: data,
  });
}

function fetchSubjectById(id) {
  return axios.get(`api/v1/subjects/${id}`);
}

function addSubjects(data) {
  return axios.post(`api/v1/subjects`, data, {
    headers: {
      "Content-Type": "form-data",
    },
  });
}

function updateSubject(subjectId, data) {
  return axios.post(`api/v1/subjects/${subjectId}`, data, {
    headers: {
      "Content-Type": "form-data",
    },
  });
}

function deleteSubject(subjectId) {
  return axios.delete(`api/v1/subjects/${subjectId}`);
}

function getParents() {
  return axios.get(`api/v1/subjects/parent`);
}

export {
  getParents,
  fetchSubjectStats,
  fetchSubjectsAcademicView,
  fetchNonAcademicStats,
  fetchStudentActivities,
  createInstitutionActivity,
  updateInstitutionActivity,
  deleteInstitutionActivity,
  fetchSubjectTypes,
  fetchSubjectList,
  fetchSubjectById,
  addSubjects,
  updateSubject,
  deleteSubject,
};
